import _ from 'lodash';
import dayjs from 'dayjs';
import { Message, MessageBox } from 'element-ui';
import { searchFieldSeperated, validateSearchTime } from '@/modules/transport/otp/views/distributeManage/receiptCenter/search.js';

/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
export const formatSearchData = data => {
    const params = _.cloneDeep(data);
    const advanceList = ['carrierName', 'carrierCode', 'driver', 'driverContactWay'];
    advanceStringToArray(params, advanceList);
    params.dispatchNoList = searchFieldSeperated(params.dispatchNo || '');
    params.dispatchTimeStart = params.dispatchTime ? dayjs(params.dispatchTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.dispatchTimeEnd = params.dispatchTime ? dayjs(params.dispatchTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    delete params.dispatchNo;
    delete params.dispatchTime;
    return params;
};

const advanceStringToArray = (data, advanceList) => {
    advanceList.forEach(key => {
        if (data[key]) {
            data[`${key}List`] = data[key] ? data[key].split(',') : [];
        }
        delete data[key];
    });
};

/**
 * @description 校验查询参数
 * @param {Object} data 查询参数
 */
export const validateSearchData = (data, maxNum = 100) => {
    const dispatchNoIsExit = data.dispatchNoList && data.dispatchNoList.length > 0;
    const driverListIsExit = data.driverList && data.driverList.length > 0;
    const dispatchTimeIsExit = data.dispatchTimeStart && data.dispatchTimeEnd;
    if (!dispatchNoIsExit && !driverListIsExit && !dispatchTimeIsExit) {
        Message.warning('发车单号为空时，司机和发车时间任一必填');
        return false;
    }
    const batchSearchField = ['dispatchNoList'];
    if (maxLengthVerification(data, batchSearchField, maxNum)) {
        Message.warning(`按照单号查询，每次最多支持查询${maxNum}单`);
        return false;
    }
    return validateSearchTime(data, 'dispatchTimeStart', 'dispatchTimeEnd', 62);
};

const maxLengthVerification = (data, fieldList, maxNum = 100) => {
    return fieldList.some(v => data[v] && data[v].length > maxNum);
};

export const formatTotalDataList = (data) => {
    if (!data.length) return [];
    data.forEach((item) => {
        item.hiddenEvent = [];
        // 当分账单状态=已分账，且支付状态=待支付、支付失败、为空时，显示调整按钮
        if (+item.divideStatus !== 1 || ![null, '0', '3'].includes(item.payStatus)) {
            item.hiddenEvent.push('adjust');
        }
        // 仅已分账 且分账对账=天津安得且支付状态=匹配支付订单异常的 可发起 匹配支付订单
        if (+item.divideStatus !== 1 || +item.payObject !== 1 || +item.payStatus !== 4) {
            item.hiddenEvent.push('matchPaymentOrder');
        }
    });
    return data;
};

/**
 * @description 按钮操作 二次确认的消息提示
 * @param {String} tipsInfo 提示信息
 * @param {String} api 调用的接口
 * @param {Array/String/Object} params 接口参数
 * @param {String} successTips 操作成功的提示
 * @param {Object} that 接收函数调用者的 this
 */
export const messageTips = (tipsInfo = '此操作将永久修改该数据, 是否继续？', api, params, successTips = '操作成功', that) => {
    MessageBox.confirm(tipsInfo, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning',
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                api(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            Message.success(successTips);
                            done();
                        }
                    })
                    .catch((errMsg) => {
                        Message.error(errMsg);
                    })
                    .finally(() => {
                        instance.confirmButtonLoading = false;
                        done();
                        that.getList();
                    });
            } else {
                done();
            }
        }
    }).catch(() => { }); // 添加错误捕获
};
